import { inject, Pipe, type PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TelemetryResponse } from '@key-telematics/fleet-api-client';
import { MapMarkersService } from 'app/shared/components/map/map-markers.service';
import { isBLETracker } from 'app/shared/utils/devices.utils';

@Pipe({
    name: 'mapIcon',
    standalone: true,
})
export class MapIconPipe implements PipeTransform {

    private sanitizer = inject(DomSanitizer);
    private mapMarkersService = inject(MapMarkersService);

    transform(
        telemetry: TelemetryResponse,
        color: string,
        size: number = 20,
        hasTrip: boolean = true,
        asset?: unknown
    ): SafeHtml {
        if (!telemetry) { return ''; }
        const isGemini = asset && isBLETracker(asset);
        const iconType = isGemini ? 'gemini-x' : this.mapMarkersService.getTelemetryIconType(telemetry, hasTrip);

        const icon = this.mapMarkersService.getIconSvgString(iconType, {
            fill: color,
            rotation: telemetry.location && telemetry.location.heading || 0,
            size,
            dropShadowAlpha: 0,
        }, hasTrip);
        return this.sanitizer.bypassSecurityTrustHtml(icon);
    }

}